import { ReactNode, createContext, useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { useApi } from "../../services/api";
import { User } from "../../types/User";

import "react-toastify/dist/ReactToastify.css";
export interface TelasCustom {
  cdTelaCustomPessoa: number;
  cdTelaCustom: number;
  dsTelaCustom: string;
  cdPessoa: number;
  dtHoraCriado: string;
  dtHoraAlterado: string;
  parceriaId: number;
}

export type AuthContextType = {
  user: User | null;
  UserLogin: (email: string, password: string) => Promise<boolean>;
  telasCustom: TelasCustom[];
  signout: () => void;
};

export const AuthContext = createContext({} as AuthContextType);

interface AuthProviderProps {
  children: ReactNode;
}
export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [user, setUser] = useState<User | null>(null);
  const [telasCustom, setTelasCustom] = useState<TelasCustom[]>([]);
  const api = useApi();

  useEffect(() => {
    const validateToken = async () => {
      const token = sessionStorage.getItem("token");
      const user = sessionStorage.getItem("nmNome");
      const tipoPessoa = sessionStorage.getItem("tipoPessoa");

      if (token) {
        setUser(user as User);
      }
    };
    validateToken();
  }, []);

  const UserLogin = async (
    email: string,
    password: string,
    logado?: boolean,
    tipoPessoa?: string,
    token?: string
  ) => {
    await api
      .UserLogin(email, password)
      .then((res) => {
        setUser(res.data.dsLogin);
        setUser(res.data.nmNome);

        tipoPessoa = res.data.tipoPessoa.cdTipoPessoa;
        token = res.data.token;

        sessionStorage.setItem("snNovaInterface", res.data.snNovaInterface);
        userStorage(res.data.nmNome);
        setToken(token);
        setTipoPessoa(tipoPessoa);
        setTelasCustom(res.data.telasCustom);

        //insere todos os res.data.telasCustom.dsTelaCustom no sessionStorage("ListTelasCustom")
        const nomesTelas = res.data.telasCustom.map(
          (tela) => tela.dsTelaCustom
        );
        if (res.data.telasCustom.length > 0) {
          sessionStorage.setItem(
            "parceriaId",
            res.data.telasCustom[0].parceriaId
          );
        }
        sessionStorage.setItem("ListTelasCustom", JSON.stringify(nomesTelas));
        logado = true;
      })
      .catch((err) => {
        //const { data } = err.response;
        // toast.error(err.response.data.message);

        logado = false;
      });

    return logado;
  };
  const signout = async () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("nmNome");
    setUser(null);
  };

  const userStorage = (user: string) => {
    sessionStorage.setItem("nmNome", user);
  };
  const setToken = (token: string) => {
    sessionStorage.setItem("token", token);
  };

  const setTipoPessoa = (tipoPessoa: string) => {
    sessionStorage.setItem("tipoPessoa", tipoPessoa);
  };

  return (
    <AuthContext.Provider value={{ user, UserLogin, signout, telasCustom }}>
      {children}
    </AuthContext.Provider>
  );
};
